define('views/blocks/ListingDeliveryOptionsView',['underscore','jquery','backbone','app', 'SubView',
    'AddressAutocompleteView',
    'views/blocks/DateTimeSelectorView',
    'views/blocks/AddressIconAliasSelectorView',
    'template!blocks/listing/top-infos'],
    function (_,$,Backbone,app,SubView,
              AddressAutocompleteView,
              DateTimeSelectorView,
              AddressIconAliasSelectorView,
              listingTopInfosTemplate
    ) {

    //
    // Listing Delivery Options bar View
    //

    var updateDeliveryDelayInterval;

    return Backbone.View.extend(SubView).extend({
        events:{
            'click .switch-delivery': 'clickSwitchDeliveryType',
            'click .delivery-address-update': 'clickDeliveryAddressUpdate',
            'click .delivery-address-alias': 'clickDeliveryAddressAlias',
            'click .delivery-datetime-update': 'clickDeliveryDatetimeUpdate'
        },
        initialize:function(){
            var view = this, cart = app.getCart();
            view.subviews = [];
            view.listenTo(cart,'deliveryUpdate delayHasChanged',view.onDeliveryUpdate);
            view.listenTo(cart,'order_time_min',view.updateDeliveryDelay);
            view.listenTo(cart.getProducts(),'add remove update',view.onChangeCartQuantity);
            view.listenTo(app,'changeAddressAlias',view.onDeliveryUpdate);
            view.onDeliveryUpdate();
            view.render();
            clearInterval(updateDeliveryDelayInterval);
            view.autoUpdateDeliveryDelay();
            view.updateDeliveryDelay();
        },

        render:function(){
          var view = this, cart = app.getCart();
            view.$el.html(listingTopInfosTemplate({cart:cart, customer:app.getCustomer()}));
            view.onChangeCartQuantity();
            // view.$('.delivery-type button').attr('disabled',true);
            //view.$('.delivery-address').text(cart.getDisplayAddress());
            // if(cart.isVAE()){
            //     view.$('.delivery-type button.vad').removeClass('disabled');
            // }else{
            //     view.$('.delivery-type button.vae').removeClass('disabled');
            // }
        },

        updateDeliveryDelay:function(){
            var view = this, cart = app.getCart();
            if(!$(document,view.el)){
                //
                return clearInterval(updateDeliveryDelayInterval);
            }
            view.$('.delivery-delay .value').html(cart.formatDeliveryTimeLabel('top-infos')).attr('title',cart.getDeliveryDelay().moment_min.format('LLLL'));
        },

        autoUpdateDeliveryDelay:function(){
            var view = this;
            updateDeliveryDelayInterval = setInterval(function(){
                view.updateDeliveryDelay()
            },20*1000);
        },

        clickDeliveryAddressUpdate:function(){
            this.openAddressAutocomplete('all');
        },

        clickDeliveryAddressAlias:function(){
            var view = this,
                wrapper = view.$('.address-icon-alias-selector__wrapper');
            wrapper.append('<div class="address-icon-alias-selector__x"></div>');
            view.appendView(AddressIconAliasSelectorView,'.address-icon-alias-selector__x',{type:'cart'});
        },

        clickDeliveryDatetimeUpdate:function(){
            this.openDatetimeSelector();
        },

        clickSwitchDeliveryType:function(e){
            //
            var cart = app.getCart();
           if($(e.currentTarget).is('.vae')){
               cart.switchToVAE();
            }else{
               cart.switchToVAD();
            }
        },

        onChangeCartQuantity:function(cart){
            var quantity = app.getCart().getQuantity();
            quantity = quantity>100 ? '+':quantity;
            this.$('.cart-product-count').text(quantity).attr('data-count',quantity);
        },

        openAddressAutocomplete:function(type){
            var view = this,
                addressAutocompleteView = new AddressAutocompleteView({type:type,theme:'modal', autoSubmit:true, ignoreInitialSelection:true});
            view.listenTo(addressAutocompleteView,'complete',view.completeAddressAutocomplete);
            app.displayModal(addressAutocompleteView);
        },

        completeAddressAutocomplete:function(addressAutocompleteView){
            addressAutocompleteView.trigger('close',addressAutocompleteView);
        },

        openDatetimeSelector:function(){
            app.displayModal(new DateTimeSelectorView());
        },

        onDeliveryUpdate:function(){
            this.render();
        }
    });
});
